import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Route, Routes } from 'react-router-dom'
import './App.css'
import { Authorization } from './components/authorization/Authorization'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ResolutionLimit } from './components/resolutionLimit/ResolutionLimit'
import { TankInfoProvider } from './components/tankInfo/TankInfoProvider'
import { TestErrorComponent } from './components/TestErrorComponent'
import Chart from './pages/Chart'
import Home from './pages/Home'
import Layout from './pages/Layout'
import Live from './pages/Live'
import { Login } from './pages/Login'
import NotFound404 from './pages/NotFound404'

const queryClient = new QueryClient({/* ... */ });

// This code is only for TypeScript
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: typeof queryClient;
  }
}

// This code is for all users
window.__TANSTACK_QUERY_CLIENT__ = queryClient;

function App() {
  return (
    <ErrorBoundary>
      <TestErrorComponent />
      <QueryClientProvider client={queryClient}>
        <Routes>
          {/* Login route */}
          <Route path="/login" element={<Login />} />

          {/* Main application routes */}
          <Route
            path="/"
            element={
              <Authorization>
                <ResolutionLimit>
                  <TankInfoProvider>
                    <Layout />
                  </TankInfoProvider>
                </ResolutionLimit>
              </Authorization>
            }
          >
            <Route path="" element={<Home />} />
            <Route path="chart" element={<Chart />} />
            <Route path="live" element={<Live />} />
          </Route>

          {/* 404 route */}
          <Route path="*" element={<NotFound404 />} />
        </Routes>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
